import {formatWithMask} from 'react-native-mask-input';

export type CardMask = (string | RegExp)[];

export const numberMask: CardMask = [
  /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/
];
export const expiryMask: CardMask = [/\d/, /\d/, '/', /\d/, /\d/];
const cvcMask: RegExp[] = [/\d/, /\d/, /\d/];

type CardMetadata = { gaps: number[], lengths: number[], code: { size: number } };

export const buildMaskFromCard = (card?: CardMetadata | null) => {
  if (!card) return {cardNumberMask: numberMask, codeSizeMask: cvcMask};

  const cardNumberMask: CardMask = [];
  const codeSizeMask: RegExp[] = [];
  const maxLength = card.lengths[card.lengths.length - 1];

  for (let i = 0; i < maxLength; i++) {
    if (card.gaps.includes(i)) cardNumberMask.push(' ');
    cardNumberMask.push(/\d/);
  }

  for (let i = 0; i < card.code.size; i++) codeSizeMask.push(/\d/);

  return {cardNumberMask, codeSizeMask};
};

export const buildCardSummaryLabelFromNumber = (brandName: string | undefined, number: string) => {
  const lastFour = number.slice(-4);
  return `${brandName || 'Card'} ••••${lastFour || '----'}`;
};

export const buildCardSummaryLabel = (brandName: string | undefined, cardNumber: string, cardNumberMask: CardMask) => {
  const {unmasked} = formatWithMask({text: cardNumber, mask: cardNumberMask});
  return buildCardSummaryLabelFromNumber(brandName, unmasked);
};
